import { SeeqNames } from '@seeqdev/constants';
import { faBarChart, faLineChart, faSortAmountAsc, faSortAmountDesc } from '@seeqdev/icons/fa-sharp-regular-svg-icons';
import type { IconDefinition } from '@seeqdev/icons';

export enum OutputType {
  CONDITION = 'CONDITION',
  SIGNAL = 'SIGNAL',
}

export enum OutputSignalType {
  LOGLIKE = 'loglike_signal',
  T2 = 't2_signal',
  SPE = 'spe_signal',
}

const packageName = SeeqNames.MlService.PrincipalComponentAnalysis.Connection.UdfPackage;
const udfName = SeeqNames.MlService.PrincipalComponentAnalysis.Connection.UdfName;
export const UDF_NAME = `${packageName}_${udfName}`;

export const LOADINGS_KEY = 'PCA loadings';
export const MODEL_INPUT_PROPERTIES = 'model_input_properties';
export const SORT_AS_STRING = true;
export const EXPLAINED_VARIANCE_KEY = 'Explained variance ratio';
export const CUMULATIVE_R_SQUARED = 'Cumulative R-squared';
export const DEFAULT_NUM_COMPONENTS = 3;
export const DEFAULT_ANOMALY_THRESHOLD = 99;
export const DEFAULT_MONITORING_CONTRAST = 0.5;
export const VALIDATION_ERROR_DELAY = 500;
export const MIN_NUM_COMPONENTS = 1;
export const MAX_MONITORING_CONTRAST = 5;
export const MAX_THRESHOLD = 100;

export const OUTPUT_SIGNAL_TYPES = [
  {
    key: OutputSignalType.LOGLIKE,
    display: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.LOG_LIKE_LABEL',
    description: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.LOG_LIKE_DESCRIPTION',
  },
  {
    key: OutputSignalType.T2,
    display: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.T2_LABEL',
    description: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.T2_DESCRIPTION',
  },
  {
    key: OutputSignalType.SPE,
    display: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.SPE_LABEL',
    description: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.SPE_DESCRIPTION',
  },
];

export const SORT_TYPES = [
  {
    label: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.CHART.ASCENDING',
    icon: faSortAmountAsc,
    option: { ascending: true, absolute: false },
  },
  {
    label: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.CHART.ABSOLUTE_ASCENDING',
    icon: faSortAmountAsc,
    option: { ascending: true, absolute: true },
  },
  {
    label: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.CHART.DESCENDING',
    icon: faSortAmountDesc,
    option: { ascending: false, absolute: false },
  },
  {
    label: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.CHART.ABSOLUTE_DESCENDING',
    icon: faSortAmountDesc,
    option: { ascending: false, absolute: true },
  },
];

export const CHART_TYPES: { key: string; label: string; icon: IconDefinition; iconExtraClassNames?: string }[] = [
  {
    key: 'bar',
    label: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.CHART.BAR',
    icon: faBarChart,
  },
  {
    key: 'column',
    label: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.CHART.COLUMN',
    icon: faBarChart,
    iconExtraClassNames: 'fa-rotate-270',
  },
  {
    key: 'line',
    label: 'INVESTIGATE_TOOLS.PRINCIPAL_COMPONENT_ANALYSIS.CHART.LINE',
    icon: faLineChart,
  },
];
